import { useEffect, useState } from 'react';

const navItems = [
  { label: '热门榜单', href: '#ranking' },
  { label: '站内爆款', href: '#viral' },
  { label: '口碑节目', href: '#classic' },
  { label: '编辑精选', href: '#picks' },
  { label: '数据洞察', href: '#insights' },
  { label: '追热门指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen ? 'bg-background-50/95 backdrop-blur border-b border-background-200/80' : 'bg-transparent'
      }`}
    >
      <nav className="flex h-16 items-center justify-between gap-4 px-4 md:h-[72px] md:px-8">
        <a href="#top" className="flex items-center gap-2.5 shrink-0" aria-label="返回页面顶部">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </span>
          <span className={`flex flex-col leading-none ${scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'}`}>
            <span className="font-heading text-lg tracking-wide">西瓜视频榜单</span>
            <span className="text-[11px] opacity-80">XIGUA HOT RANKING</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#ranking"
            className="hidden md:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-fire-line"></i>
            查看榜单
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled || menuOpen ? 'text-foreground-950 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200/80 bg-background-50 px-4 pb-4 pt-2">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between py-3 text-sm text-foreground-800 border-b border-background-100 last:border-0"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}